import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `POST …/lists/{list}/item-moves` — `from` and `to` are 0-indexed. */
class MoveDocumentListItem {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
		public readonly listKey: string,
		public readonly from: number,
		public readonly to: number,
	) {
		Object.freeze(this);
	}

	toJSON(): { from: number; to: number } {
		return { from: this.from, to: this.to };
	}
}

export default MoveDocumentListItem;
